<template>
    <div class="jf_container">
        <myTab :tabData="tabData" @tab_index="handleTabIndex"></myTab>
        <div class="jf_conditionBox">
            <el-select
                class="assort"
                v-model="assortId"
                placeholder="请选择分类"
                clearable
                @change="searchParam.typeid=assortId;getCheckList()"
            >
                <el-option
                    v-for="item in assortArray"
                    :key="item.id+1000"
                    :label="item.typename"
                    :value="item.id"
                >
                    <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                </el-option>
            </el-select>
            <el-date-picker
                class="picker"
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="searchParam.date=date;getCheckList()"
            ></el-date-picker>
            <el-select class="assort" clearable v-model="employeeInfo" placeholder="请选择员工" value-key="user_id" @change="getCheckList">
                <el-option
                    v-for="item in employeeList"
                    :key="item.user_id"
                    :label="item.username"
                    :value="item"
                ></el-option>
            </el-select>
            <!-- <mySearch
                class="my-search"
                @searchData="searchData"
                :paramData="searchParam"
                searchApi="point_check/index"
                v-model="searchContent"
            ></mySearch> -->
        </div>
        <el-table class="elTable" :data="tableData">
            <el-table-column prop="username" label="员工姓名" header-align="center"></el-table-column>
            <el-table-column prop="typename" label="积分分类" header-align="center"></el-table-column>
            <el-table-column
                prop="rule_name"
                label="规则名称"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="rule_des"
                label="积分细则"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="content"
                label="申请说明"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="奖惩分数" header-align="center">
                <template slot-scope="scope">
                    <span
                        :style="{'color':scope.row.rule_type==1?'#67C23A':'#F56C6C'}"
                    >{{scope.row.rule_type==1?'+':'-'}}{{scope.row.score}}</span>
                </template>
            </el-table-column>
            <el-table-column label="标准分数" align="center">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.score_type == 1 ? scope.row.score_fixed: scope.row.score_min+' ~ '+scope.row.score_max}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="create_name" label="录入人" header-align="center"></el-table-column>
            <el-table-column
                prop="check_time"
                label="申请日期"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="附件" header-align="center">
                <template slot-scope="scope">
                    <a :href="scope.row.file" download v-if="scope.row.file" target="_Blank">
                        <!-- <img width="30" src="/static/qmsj/img/jifen/file.jpg" alt=""> -->
                        <span style="color:#E6BE8A">查看</span>
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" v-if="tabIndex===0">
                <template slot-scope="scope">
                    <el-button
                        @click="showDialog(scope.row.id, 1)"
                        type="text"
                        size="small"
                        style="color:#E6BE8A"
                    >通过</el-button>
                    <el-button
                        @click="showDialog(scope.row.id, 2)"
                        type="text"
                        size="small"
                        style="color:#ff5454"
                    >驳回</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 审核 对话框 -->
        <el-dialog class="elDialog" :visible.sync="verifyVisible" width="350" :show-close="false">
            <span class="tip">确认通过该积分项目吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="verifyVisible = false">取 消</el-button>
                <el-button type="warning" @click="handleChekcPass">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 驳回 对话框 -->
        <el-dialog
            class="elDialog rejectDialog"
            :visible.sync="rejectVisible"
            width="350"
            :show-close="false"
            :close-on-click-modal="false"
        >
            <span class="tip">请输入驳回理由：</span>
            <textarea class="dialogText" v-model="reason"></textarea>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rejectVisible = false">取 消</el-button>
                <el-button type="warning" @click="handleReject">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 页码 -->
        <p
            class="pageTotal"
        >共有 {{pageData.count}} 条记录 当前 {{pageData.page}} 页/共 {{pageData.pagetotal}} 页</p>
        <el-pagination
            class="pageBody"
            @current-change="getCheckList(1)"
            :current-page.sync="pageData.page"
            background
            layout="prev, pager, next"
            :total="pageData.count*1"
        ></el-pagination>
    </div>
</template>
<script>
import myTab from "../../components/myTab.vue";
import mySearch from "../../components/mySearch.vue";

var baseUrl = process.env.apiUrl + "point/";
export default {
    data() {
        return {
            activeId: "",
            verifyVisible: false,
            rejectVisible: false,
            tabData: ["未审核", "已通过", "未通过"],
            tabIndex: 0,

            // -------------
            token: "",
            tableData: [],
            pageData: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            }, // 页数
            date: "",
            searchParam: {
                from: 3,
                date: "",
                shenhe: 1
            },
            searchContent: "",
            assortArray: [],
            assortId: "",
            reason: '',  // 驳回理由
            employeeList: [],
            employeeInfo: {},
        };
    },
    components: {
        myTab,
        mySearch
    },
    created() {
        this.token = this.$cookies.get("token");
        this.getCheckList();
        this.getAssortList();
        this.getEmployee()
    },
    methods: {
        async getCheckList(type) {
            if (type !== 1) {
                this.pageData.page = 1
            }
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_check/index", {
                    token: that.token,
                    from: 3, //  1 考核列表  2.个人申请列表 3.审核列表
                    shenhe: that.tabIndex + 1, // 1.未审核 2.审核通过  3.审核驳回
                    time_s:
                        that.date && that.date.length > 0 ? that.date[0] : "",
                    time_e:
                        that.date && that.date.length > 0 ? that.date[1] : "",
                    search: that.searchContent,
                    page: that.pageData.page,
                    typeid: that.assortId,
                    uid: that.employeeInfo.user_id?that.employeeInfo.user_id: ''
                });
                if (res.status === 1) {
                    that.tableData = res.data;
                    that.pageData.count = res.map.count;
                    that.pageData.page = res.map.page*1;
                    that.pageData.pagetotal = res.map.pagetotal;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        searchData(data) {
            this.tableData = data.data;
            this.pageData.count = data.map.count;
            this.pageData.page = data.map.page*1;
            this.pageData.pagetotal = data.map.pagetotal;
        },
        // 获取分类列表
        async getAssortList() {
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_type/index", {
                    token: that.token
                });
                if (res.data && res.data.length > 0) {
                    that.assortArray = [];
                    res.data.forEach((element, index) => {
                        that.assortArray.push({
                            typename: element.typename,
                            pid: element.pid,
                            id: element.id
                        });
                        if (element.child && element.child.length > 0) {
                            element.child.forEach((ele, i) => {
                                that.assortArray.push({
                                    typename: ele.typename,
                                    pid: ele.pid,
                                    id: ele.id
                                });
                            });
                        }
                    });
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        showDialog(id, type) {
            this.activeId = id;
            if (type === 1) {
                // 1--审核， 2--驳回
                this.verifyVisible = true;
            } else {
                this.rejectVisible = true;
            }
        },
        // 审核 通过
        async handleChekcPass() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_check/do_pass",
                    { token: that.token, id: that.activeId }
                );
                if (res.status == 1) {
                    that.$message.success("已通过审核");
                    that.getCheckList();
                } else {
                    that.$message.error(res.msg);
                }
                this.verifyVisible = false;
            } catch (err) {
                that.$message.error(err);
                this.verifyVisible = false;
            }
        },
        // 审核 驳回
        async handleReject() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_check/do_rebut ",
                    { token: that.token, id: that.activeId, reason: that.reason }
                );
                if (res.status == 1) {
                    that.$message.success("已驳回");
                    that.getCheckList();
                } else {
                    that.$message.error(res.msg);
                }
                this.rejectVisible = false;
            } catch (err) {
                that.$message.error(err);
                this.rejectVisible = false;
            }
        },
        // 切换 tab
        handleTabIndex(data) {
            this.tabIndex = data;
            this.searchParam.shenhe = data*1+1
            this.date = ''
            this.searchContent = ''
            this.assortId = ''
            this.getCheckList();
        },
        // 获取员工列表
        async getEmployee() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_check/get_user_info",
                    {
                        token: that.token
                    }
                );
                if (res.status == 1) {
                    that.employeeList = res.allusers;
                    that.enter_user = res.username;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
    }
};
</script>
<style scoped>
.jf_container {
    min-width: 800px;
}
.jf_conditionBox {
    width: 100%;
    height: 60px;
    padding-top: 10px;
    padding-left: 30px;
    background: #f5f5f5;
}
.elTable {
    width: 96%;
    margin: 20px 0 0 30px;
    text-align: center;
}
.assort {
    float: left;
}
.picker {
    float: left;
    margin-left: 20px;
    margin-right: 20px;
}
.my-search {
    float: right;
    margin-right: calc(4% - 30px);
}
.dialogText {
    border-radius: 4px;
    width: 280px;
    height: 90px;
    padding: 6px;
    outline: none;
    resize: none;
}
.rejectDialog textarea {
    margin: 10px 14px 0;
}
.secondary {
    margin-left: 30px;
}
/* .file {
    width: 30px;
} */
</style>



// WEBPACK FOOTER //
// src/pages/jifen/shenhe.vue